/**
 * RgpdAccountDeletionController — modale `#modal-rgpd-suppression` du
 * bloc `#block-suppression-compte` de /profil-utilisateur.html
 * (EPIC-036 / 36.5).
 *
 * Suppression de compte (RGPD art. 17) — modalité V1 « via le support » :
 *   1. clic « Demander la suppression » → open()  → showModal()
 *   2. clic « Confirmer ma demande »    → confirm() → POST
 *      `/rgpd/account-deletion-request` puis ouverture du `mailtoUrl`
 *      retourné (laisse l'utilisateur formaliser la demande dans son
 *      client mail) + toast succès.
 *
 * Conformément à la maquette 36.1, la modale n'a pas de textarea motif :
 * `reason` est laissé à `null`, l'utilisateur précise son motif dans le
 * client mail qui s'ouvre. Le bouton « Annuler » utilise `<form
 * method="dialog">` (HTML5 natif), donc pas de méthode `close` ici.
 */

import BaseController from "./base_controller.js";
import { api } from "/js/services/api.js";

export default class RgpdAccountDeletionController extends BaseController {
  static targets = ["modal", "confirmBtn", "error"];

  open(event) {
    if (event) event.preventDefault();
    if (this.hasModalTarget && typeof this.modalTarget.showModal === "function") {
      this._clearError();
      this.modalTarget.showModal();
    }
  }

  close(event) {
    if (event) event.preventDefault();
    if (this.hasModalTarget && typeof this.modalTarget.close === "function") {
      this.modalTarget.close();
    }
  }

  async confirm(event) {
    event.preventDefault();
    if (this.hasConfirmBtnTarget) this.confirmBtnTarget.disabled = true;
    try {
      const data = await api.requestAccountDeletion({ reason: null });
      const mailtoUrl = data && typeof data.mailtoUrl === "string" ? data.mailtoUrl : null;
      this.close();
      this.showSuccess(
        "Demande enregistrée. Votre client mail va s'ouvrir pour formaliser la demande auprès du support.",
      );
      if (mailtoUrl) {
        window.location.assign(mailtoUrl);
      }
    } catch (error) {
      const msg = error && error.message
        ? error.message
        : "Erreur lors de la demande de suppression.";
      this._showError(msg);
    } finally {
      if (this.hasConfirmBtnTarget) this.confirmBtnTarget.disabled = false;
    }
  }

  _showError(msg) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = msg;
      this.errorTarget.hidden = false;
    } else {
      this.showError(msg);
    }
  }

  _clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = "";
      this.errorTarget.hidden = true;
    }
  }
}
